import styles from "./PickupAndRefillLocation.module.css";
import { LocationCard } from "./LocationCard/LocationCard";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { LocationConnector } from "./LocationCard/LocationConnector/LocationConnector";
import { useTranslation } from "@coworker/locales";
import {
  AddLocationModal,
  AddLocationTab,
} from "@coworker/apprestructured/src/task-management/components/AddLocation/AddLocationModal";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";
import {
  GroupedSalesLocations,
  LocationChange,
} from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import ErrorAddOn from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";

type LocationModalProps = {
  visible: boolean;
  onClose: () => void;
  onTabChanged: (tabId: AddLocationTab) => void;
  itemNoAndType: ItemNoAndType | null;
  slid: string;
  customLocation: string;
  onConfirmClick: ({ slid, customLocation }: LocationChange) => void;
  isLoadingLocations: boolean;
  filteredLocations: GroupedSalesLocations;
  totalAssignedSalesSpaceQuantity: number;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

type PickupAndRefillLocationProps = {
  pickupLocation: string;
  refillLocation: string;
  isPickUpAndRefillLocationSame: boolean;
  showValidation: boolean;
  onPickupClick?: () => void;
  onRefillClick?: () => void;
  disabled?: boolean;
  locationModalProps?: LocationModalProps;
};

function PickupAndRefillLocation({
  pickupLocation,
  refillLocation,
  isPickUpAndRefillLocationSame,
  showValidation,
  onPickupClick,
  onRefillClick,
  disabled,
  locationModalProps,
}: PickupAndRefillLocationProps) {
  const { t } = useTranslation();
  const hasRequiredLocations =
    pickupLocation.length > 0 && refillLocation.length > 0;
  const hasMissingLocationError = !hasRequiredLocations;

  return (
    <div className={styles["container"]}>
      <div className={styles["topWrapper"]}>
        <LocationConnector />
        <div className={styles["cardWrapper"]}>
          <LocationCard
            title={t("pickupLocation")}
            subtitle={t("homebaseString")}
            location={pickupLocation}
            type="pickup"
            onClick={onPickupClick}
            disabled={disabled}
          />
          <LocationCard
            title={t("refillLocString")}
            location={refillLocation}
            type="refill"
            onClick={onRefillClick}
            disabled={disabled}
          />
        </div>
      </div>
      {isPickUpAndRefillLocationSame && (
        <FixaInlineMessage
          variant="negative"
          title={t("pickupAndRefillLocationCannotBeSameString")}
        />
      )}
      {showValidation && hasMissingLocationError ? (
        <div className={styles["validationError"]}>
          <ErrorAddOn>{t("pleaseFillInString")}</ErrorAddOn>
        </div>
      ) : null}
      {locationModalProps && (
        <AddLocationModal
          visible={locationModalProps.visible}
          onClose={locationModalProps.onClose}
          onTabChanged={locationModalProps.onTabChanged}
          itemNoAndType={locationModalProps.itemNoAndType}
          slid={locationModalProps.slid}
          customLocation={locationModalProps.customLocation}
          onConfirmClick={locationModalProps.onConfirmClick}
          isLoadingLocations={locationModalProps.isLoadingLocations}
          filteredLocations={locationModalProps.filteredLocations}
          totalAssignedSalesSpaceQuantity={
            locationModalProps.totalAssignedSalesSpaceQuantity
          }
          searchQuery={locationModalProps.searchQuery}
          setSearchQuery={locationModalProps.setSearchQuery}
          showNamingGuidelines
        />
      )}
    </div>
  );
}

export default PickupAndRefillLocation;
